var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.026,
    height: 26.48,
    viewBox: "0 0 31.026 26.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "my-health-1",
    transform: "translate(0.15 -31.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322",
    transform: "translate(7.349 31.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M114.141,33.142c-1.555-1.465-4.22-1.8-6.631.611-2.407-2.408-5.076-2.076-6.631-.612a4.391,4.391,0,0,0-.1,6.3l6.728,6.729,6.728-6.728A4.391,4.391,0,0,0,114.141,33.142ZM113.4,38.61,107.51,44.5l-5.892-5.892A3.207,3.207,0,0,1,101.69,34a3.078,3.078,0,0,1,2.13-.827c1.692,0,2.453,1.012,3.691,2.249,1.2-1.2,1.979-2.249,3.691-2.249a3.087,3.087,0,0,1,2.131.826A3.207,3.207,0,0,1,113.4,38.61Z",
    transform: "translate(-99.496 -31.992)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324",
    transform: "translate(17.726 33.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M250.98,48.009a2.012,2.012,0,0,0-2.009,1.815l-.748,7.387a1.9,1.9,0,0,0-.948.508l-5.969,5.557A4.013,4.013,0,0,0,240,66.207v6.619h7.091V69.711a1.789,1.789,0,0,1,.568-1.3l4.485-4.526a2.94,2.94,0,0,0,.856-2.08V50.029A2.022,2.022,0,0,0,250.98,48.009Zm.838,13.8a1.764,1.764,0,0,1-.514,1.249l-4.471,4.512a2.959,2.959,0,0,0-.924,2.141v1.933h-4.727v-5.43a2.823,2.823,0,0,1,.925-2.066l5.988-5.577a.782.782,0,0,1,1.086,0,.765.765,0,0,1,.226.544.756.756,0,0,1-.206.524l-4.61,4.181.794.875,4.631-4.2a1.949,1.949,0,0,0,0-2.757,1.886,1.886,0,0,0-.618-.417l.746-7.374a.838.838,0,0,1,1.672.084Z",
    transform: "translate(-240 -48.009)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326",
    transform: "translate(0 33.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M11.694,63.276,5.724,57.72a1.888,1.888,0,0,0-.948-.508l-.748-7.387a2.019,2.019,0,0,0-4.029.2v11.78a2.935,2.935,0,0,0,.856,2.079L5.34,68.413a1.792,1.792,0,0,1,.568,1.3v3.115H13V66.207A4.011,4.011,0,0,0,11.694,63.276Zm.124,8.368H7.091V69.711a2.961,2.961,0,0,0-.924-2.141L1.7,63.058a1.764,1.764,0,0,1-.514-1.249V50.029a.838.838,0,0,1,1.672-.086L3.6,57.317a1.949,1.949,0,0,0-.617,3.174l4.631,4.2.794-.874L3.8,59.636a.749.749,0,0,1-.206-.524.763.763,0,0,1,.226-.544.782.782,0,0,1,1.086,0l5.988,5.577a2.823,2.823,0,0,1,.925,2.066v5.433Z",
    transform: "translate(0 -48.009)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHealth);
export default __webpack_public_path__ + "static/media/icon_health.c5760ac98a8c2e3870ec135d7a785cbf.svg";
export { ForwardRef as ReactComponent };